import { createSlice } from "@reduxjs/toolkit";
import { balanceApi } from "./balance.api";
import { BalanceProfileStatus, } from "./balance.types";
// Api response type
const initialState = {
    currentTier: {
        currentBalanceValue: 0,
        lastDateTransaction: "",
        pointsToNextTier: 0,
        configuration: {
            tierName: "-",
            tierCode: "-",
            tierTitle: "-",
            minThreshold: 0,
            maxThreshold: 0,
            tierDescription: "-",
        },
    },
    nextTierConfig: {
        tierName: "-",
        tierCode: "-",
        tierTitle: "-",
        minThreshold: 0,
        maxThreshold: 0,
        tierDescription: "-",
    },
    dictionary: {},
    loyaltyProfile: {
        profileStatus: BalanceProfileStatus.UNKNOWN,
        reactivationDeadline: "2023-09-21T10:51:13.149Z",
    },
};
export const balanceSlice = createSlice({
    name: "balance",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addMatcher(balanceApi.endpoints.getBalance.matchFulfilled, (state, action) => {
            return Object.assign(Object.assign({}, state), action.payload);
        });
    },
});
//# sourceMappingURL=balance.slice.js.map